import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-crown-border bg-crown-bg mt-auto" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-70">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-71">
          <div className="text-crown-muted text-sm" data-id="element-72">© 2024 CrownControl™</div>
          <div className="flex gap-6" data-id="element-73">
            <a href="#" className="text-crown-muted hover:text-crown-body text-sm transition-colors" data-id="element-74">
              Privacy Policy
            </a>
            <a href="#" className="text-crown-muted hover:text-crown-body text-sm transition-colors" data-id="element-75">
              Terms
            </a>
            <a href="#" className="text-crown-muted hover:text-crown-body text-sm transition-colors" data-id="element-76">
              Medical Disclaimer
            </a>
          </div>
        </div>
      </div>
    </footer>;
}